import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PhotoshopSvg = function PhotoshopSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31A8FF",
    d: "M7.78 16.166V13.11h1.738c1.797 0 2.992-.98 2.992-2.654 0-1.768-1.359-2.725-3.179-2.725H6.34v8.435zm1.703-4.194H7.768v-3.12h1.674c.986 0 1.721.554 1.721 1.522 0 .95-.694 1.598-1.68 1.598m6.27 4.311c1.488 0 2.44-.682 2.44-1.85 0-.565-.293-1.382-1.53-1.69l-1.084-.263c-.66-.14-.98-.333-.98-.7 0-.525.472-.782 1.143-.782.648 0 1.068.31 1.155.828h1.208c-.03-1.16-.945-1.808-2.351-1.808-1.593 0-2.427.788-2.421 1.86.006.952.67 1.436 1.697 1.663l1.144.263c.548.117.782.332.782.712 0 .519-.485.764-1.208.764-.607 0-1.207-.274-1.365-.945h-1.248c.198 1.365 1.359 1.948 2.619 1.948"
  }));
};
export var Photoshop = function Photoshop(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PhotoshopSvg
  }));
};